import { commonViewTexts } from '../common';
import { projectImageMessagesShared } from './shared/project-image-messages';

export const projectDetailViewTexts = {
  description: 'プロジェクトの詳細情報を表示しています。',
  section1: {
    title: '登録者',
    model: commonViewTexts.model
  },
  section2: {
    title: commonViewTexts.blueprintData,
    goToProjectImageList: `${commonViewTexts.blueprintData}の管理・カウントに移動`
  },
  section3: {
    title: 'カウント結果',
    countResultDescription: '以下のカウント結果となっています。'
  },
  section4: {
    title: '結果図面・CSVファイルのダウンロード',
    buttons: {
      unapprove: '承認をキャンセルする',
      approve: '結果を承認する',
      downloadImage: '結果図面のダウンロード',
      downloadCsv: '結果CSVファイルのダウンロード'
    },
    tooltip: {
      noImageMessageForDownloadButton:
        '画像が1枚も登録されていないためダウンロードはできません。',
      noImageMessageForApproveButton:
        '画像が1枚も登録されていないため承認はできません。',
      countingNotCompletedMessageForApproveButton:
        'カウントが完了していないため承認はできません。'
    },
    downloadResultImageDescription: [
      '結果出力は、結果承認後に行うことができます。',
      'カウント結果を確認し問題が無ければ結果承認ボタンを押してください。'
    ]
  },
  message: {
    readonlyProject: projectImageMessagesShared.readonlyProjectMessage
  },
  projectImageDataSummary: ({
    numImages,
    numCounted
  }: {
    numImages: number;
    numCounted: number;
  }): string =>
    numImages === 0
      ? `${commonViewTexts.blueprintData}が登録されていません。`
      : numCounted === numImages
      ? `${numImages}枚の${commonViewTexts.blueprintData}が登録されており、すべての画像のカウントが完了しています。`
      : `${numImages}枚の${commonViewTexts.blueprintData}が登録されており、
        ${numImages - numCounted}枚の${
          commonViewTexts.blueprintData
        }がまだカウントされていません。`
} as const;
